module.exports = __webpack_public_path__ + "static/media/cross-seticap.b558796c.png";